import React, { Fragment, useState, useEffect } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import PageTitle from "../Layout/PageTitle";
import {
  Row,
  Col,
  Modal,
  Button,
  FormGroup,
  Form,
  Card,
} from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import * as SecureLS from "secure-ls";

function Content() {
  const server = window.$linkserver;
  const [permisos_nombre, setpermisos_nombre] = useState("");
  const [permisos_descripcion, setpermisos_descripcion] = useState("");

  const [dataTable, setdataTable] = useState([]);
  const [showModal, setshowModal] = useState(false);
  const [permisos, setpermisos] = useState();
  const [index, setIndex] = useState();

  const ls = new SecureLS({
    encodingType: "des",
    isCompression: false,
    encryptionSecret: "admin-hyundai",
  });
  const { infoUsuario } = ls.get("ask-hy");
  const { data } = infoUsuario;
  const columns = [
    {
      dataField: "per_id",
      text: "Codigo",
      sort: true,
    },
    {
      dataField: "per_nombre",
      text: "Nombre",
      sort: true,
    },
    {
      dataField: "per_descripcion",
      text: "Descripción",
    },
    {
      dataField: "per_estado",
      text: "Estado",
      formatter: (cell, row, index) => activeDesactive(row, index),
      sort: true,
    },

    {
      dataField: "PER_EDITAR",
      text: "Editar",
      formatter: (cell, row, index) => editRow(row, index),
      sort: true,
    },
  ];

  const [error, seterror] = useState({
    nombre: "",
    descripcion: "",
  });

  const showMessage = (msn, type) => {
    Toast.fire({
      title: msn,
      icon: type,
      confirmButtonText: "Entendido",
    });
  };

  const setEstado = (estado) => {
    if (estado === 1) {
      return true;
    } else if (estado === 0) {
      return false;
    }
  };

  const changeEstado = async (item, index) => {
    if (item.per_estado === 1) {
      item.per_estado = 0;
    } else if (item.per_estado === 0) {
      item.per_estado = 1;
    }
    update(item, index);
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
  });

  const editpermisos = (row, index) => {
    setpermisos_nombre(row.per_nombre);
    setpermisos_descripcion(row.per_descripcion);
    setpermisos(row);
    setIndex(index);
    setshowModal(true);
  };

  const setDatapermisos = () => {
    permisos.per_nombre = permisos_nombre;
    permisos.per_descripcion = permisos_descripcion;
    setpermisos_nombre("");
    setpermisos_descripcion("");
    setshowModal(false);
    update(permisos, index);
  };

  const editRow = (row, index) => {
    return (
      <Button
        onClick={() => {
          editpermisos(row, index);
        }}
        color="primary"
        variant="contained"
      >
        <FontAwesomeIcon icon={faEdit} />
      </Button>
    );
  };

  const activeDesactive = (row, index) => {
    return (
      <input
        type="checkbox"
        name="something"
        value="asa"
        checked={setEstado(row.per_estado)}
        onChange={() => changeEstado(row, index)}
      />
    );
  };

  const createpermisos = async () => {
    seterror((error) => {
      return { ...error, nombre: "", descripcion: "" };
    });

    if (permisos_nombre !== "" && permisos_descripcion !== "") {
      const dataForm = new FormData();
      dataForm.append("per_nombre", permisos_nombre);
      dataForm.append("per_descripcion", permisos_descripcion);
      dataForm.append("usuario", data.US_CODIGO);

      await axios
        .post(server + "permisos/createPermiso", {
          per_nombre: permisos_nombre,
          per_descripcion: permisos_descripcion,
        })

        .then(function (response) {
          if (response.status === 200) {
            showMessage("Permiso Creado Exitosamente", "success");
            setpermisos_descripcion("");
            setpermisos_nombre("");
            getData();
          } else {
            showMessage("Error en Sercer Intentalo de nuevo", "error");
          }
        })
        .catch(function (error) {});
    } else {
      if (permisos_nombre === "") {
        seterror((error) => {
          return { ...error, nombre: "Campo requerido" };
        });
      }

      if (permisos_descripcion === "") {
        seterror((error) => {
          return { ...error, descripcion: "Campo requerido" };
        });
      }
      showMessage("Campos incompletos", "error");
    }
  };

  useEffect(() => {
    const getDataIncial = async () => {
      await axios
        .get(server + "permisos/getPermisos")
        .then(function (response) {
          setdataTable(response.data);
        })
        .catch(function (error) {})
        .then(function () {});
    };
    getDataIncial();
  }, [server]);

  const getData = async () => {
    await axios
      .get(server + "permisos/getPermisos")
      .then(function (response) {
        setdataTable(response.data);
      })
      .catch(function (error) {})
      .then(function () {});
  };

  const update = (dataUpdate, index) => {
    seterror((error) => {
      return { ...error, nombre: "", descripcion: "" };
    });

    const dataForm = new FormData();
    dataForm.append("per_id", dataUpdate.PER_CODIGO);
    dataForm.append("per_nombre", dataUpdate.PER_NOMBRE);
    dataForm.append("per_descripcion", dataUpdate.PER_DESCRIPCION);
    dataForm.append("per_estado", dataUpdate.PER_ESTADO);
    dataForm.append("usuario", data.US_CODIGO);
    dataForm.append("_method", "PUT");

    axios
      .post(server + "permisos/updatePermiso", {
        per_id: dataUpdate.per_id,
        per_nombre: dataUpdate.per_nombre,
        per_descripcion: dataUpdate.per_descripcion,
        per_estado: dataUpdate.per_estado,
      })

      .then(function (response) {
        if (response.status === 200) {
          showMessage("Permiso actualizado correctamente", "success");
          getData();
        } else {
          showMessage("Error en el server intentalo de nuevo", "error");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <Fragment>
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div>
          <PageTitle
            heading="Administracion/ Configuracion"
            icon="pe-7s-user icon-gradient bg-mean-fruit"
          />
          {/* <Container fluid={true} className="content-body"> */}
          <Row>
            <Col md="12" lg="12">
              <div>
                <div>
                  <Modal
                    show={showModal}
                    onHide={!showModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <Modal.Title id="contained-modal-title-vcenter">
                        Editar Permisos
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <FormGroup as={Row}>
                          <Form.Label column sm="2">
                            {" "}
                            Nombre:{" "}
                          </Form.Label>
                          <Col sm="10">
                            <Form.Control
                              maxLength={150}
                              type="text"
                              placeholder="Nombre de Permisos"
                              value={permisos_nombre}
                              onChange={(event) =>
                                setpermisos_nombre(event.target.value)
                              }
                            />
                          </Col>
                        </FormGroup>

                        <FormGroup as={Row}>
                          <Form.Label column sm="2">
                            {" "}
                            Descripción:{" "}
                          </Form.Label>
                          <Col sm="10">
                            <Form.Control
                              maxLength={100}
                              type="text"
                              placeholder="Descripción de Permisos"
                              value={permisos_descripcion}
                              onChange={(event) =>
                                setpermisos_descripcion(event.target.value)
                              }
                            />
                          </Col>
                        </FormGroup>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button onClick={() => setDatapermisos()}>
                        Actualizar
                      </Button>
                      <Button
                        onClick={() => {
                          setshowModal(false);
                          setpermisos_nombre("");
                          setpermisos_descripcion("");
                          seterror((error) => {
                            return { ...error, nombre: "", descripcion: "" };
                          });
                        }}
                      >
                        Cerrar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>

                <h3 className="text-center">Gestión de "Permisos"</h3>
                <Card>
                  <Card.Header as="h5">Creación de "Permisos" </Card.Header>
                  <Card.Body>
                    <Form>
                      <FormGroup as={Row}>
                        <Form.Label column sm="2">
                          {" "}
                          Nombre:{" "}
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            maxLength={150}
                            type="text"
                            placeholder="Nombre de Permiso"
                            value={permisos_nombre}
                            onChange={(event) =>
                              setpermisos_nombre(event.target.value)
                            }
                          />

                          <span style={{ color: "red" }}>{error.nombre}</span>
                        </Col>
                      </FormGroup>

                      <FormGroup as={Row}>
                        <Form.Label column sm="2">
                          {" "}
                          Descripción:{" "}
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            maxLength={100}
                            type="text"
                            placeholder="Descripción de Permisos"
                            value={permisos_descripcion}
                            onChange={(event) =>
                              setpermisos_descripcion(event.target.value)
                            }
                          />
                          <span style={{ color: "red" }}>
                            {error.descripcion}
                          </span>
                        </Col>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          variant="primary"
                          onClick={() => createpermisos()}
                        >
                          Guardar cambios
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>

                <br></br>

                <Card>
                  <Card.Header as="h5">
                    Listado general de "Permisos"
                  </Card.Header>
                  <Card.Body>
                    <BootstrapTable
                      keyField="PER_CODIGO"
                      wrapperClasses="table-responsive"
                      data={dataTable}
                      columns={columns}
                    />
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
          {/* </Container> */}
        </div>
      </ReactCSSTransitionGroup>
    </Fragment>
  );
}

export default Content;
